<template>
  <div class="PieChart">
    <svg ref="chart"></svg>
    <div ref="tooltip" class="Tooltip"></div>
  </div>
</template>

<script>
  // https://codepen.io/zakariachowdhury/pen/OWdyjq

  import * as d3 from 'd3';
  import { rgba, capitalize } from '@/legacy/lib//template';

  export default {
    props: {
      data: {
        type: Array
      }
    },

    mounted: function () {
      let svg     = d3.select (this.$refs.chart);
      let tooltip = d3.select (this.$refs.tooltip);

      let padding = 40;

      let margin = {
        top:    0,
        right:  0,
        bottom: 0,
        left:   0
      };

      let boundingBox = svg
        .node ()
        .getBoundingClientRect ();

      let width  = boundingBox.width - margin.left - margin.right;
      let height = boundingBox.height - margin.top - margin.bottom;

      let radius = Math.min (width - padding, height - padding) / 2;

      svg
        .attr ('width', width)
        .attr ('height', height);

      let g = svg
        .append ('g')
        .attr ('transform', `translate(${width / 2}, ${height / 2})`);

      let arc = d3
        .arc ()
        .innerRadius (0)
        .outerRadius (radius);

      let pie = d3
        .pie ()
        .value (d => d.value)
        .sort (null);

      let path = g
        .selectAll ('path')
        .data (pie (this.data))
        .enter ()
        .append ('g')
        .append ('path')
        .attr ('d', arc)
        .attr ('fill', d => rgba (`--wc3-${d.data.colour}`))
        .style ('opacity', .8)
        .style ('stroke', 'white')

        .on ('mouseover', function (d) {
          d3
            .select (this)
            .style ('opacity', .6);

          tooltip
            .html (`<strong>${capitalize (d.data.label)}:</strong> ${d.data.value}`)
            .style ('display', 'block');

          tooltip
            .style ('left', `20px`)
            .style ('top', `20px`)
        })

        .on ('mousemove', d => {
        })

        .on ('mouseout', function (d) {
          tooltip
            .style ('display', 'none');

          svg
            .selectAll ('path')
            .style ('opacity', .8);
        });
    }
  };
</script>

<style lang="scss" scoped>
  .PieChart {
    position: relative;
    height: 100%;

    svg {
      width: 100%;
      height: 100%;
    }

    text {
      fill: rgba(var(--white), 0.8);
      // font-size: fetch(font m);
      font-family: fetch(font family);
    }
  }

</style>